module.exports = __webpack_public_path__ + "static/media/show-list-red.b54e722f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/show-list-red.svg
// module id = 1562
// module chunks = 0